import type { ApiClient } from "@/lib/api";

export const deleteConnectedAccounts = async ({
  client,
  connectionId,
}: {
  client: ApiClient;
  connectionId: string;
}) => {
  const { data } = await client.delete(`/user_connections/${connectionId}`);
  return data;
};
